module.exports = "/_next/static/videos/lead-social-b20a7f52f9acafebfb4e336395915090.mp4";